<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <custom-field 
          :label="customLabel.ap_text1 || '自定义字段1'"
          v-model="form.main.ap_text1" :caller="caller" fieldName="ap_text1"
          slot="ap_text1" hidden="true"
        />
        <custom-field
          :label="customLabel.ap_text2 || '自定义字段2'"
          v-model="form.main.ap_text2" :caller="caller" fieldName="ap_text2"
          slot="ap_text2" hidden="true"
        />
        <custom-field 
          :label="customLabel.ap_text3 || '自定义字段3'"
          v-model="form.main.ap_text3" :caller="caller" fieldName="ap_text3"
          slot="ap_text3" hidden="true"
        />
        <custom-field 
          :label="customLabel.ap_text4 || '自定义字段4'"
          v-model="form.main.ap_text4" :caller="caller" fieldName="ap_text4"
          slot="ap_text4" hidden="true"
        />
        <custom-field 
          :label="customLabel.ap_text5 || '自定义字段5'"
          v-model="form.main.ap_text5" :caller="caller" fieldName="ap_text5"
          slot="ap_text5" hidden="true"
        />
      </custom-layout>
      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>产品{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail1">
            <product-field
              slot="pr_detail"
              :label="customLabel.pr_detail || '产品名称'"
              v-model="item.productDTO.pr_detail"
              @select="onSelectProduct($event, item)"
            />
            <div
              class="weui-cell"
              v-if="item.productDTO.pr_orispeccode"
              slot="pr_orispeccode"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pr_orispeccode || "型号"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                {{ item.productDTO.pr_orispeccode }}
              </div>
            </div>
            <div
              class="weui-cell"
              v-if="item.productDTO.pr_spec"
              slot="pr_spec"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pr_spec || "规格"
                }}</label>
              </div>
              <div class="weui-cell__bd">{{ item.productDTO.pr_spec }}</div>
            </div>
            <div
              class="weui-cell"
              v-if="item.productDTO.pr_brand"
              slot="pr_brand"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.pr_brand || "厂家/品牌"
                }}</label>
              </div>
              <div class="weui-cell__bd">{{ item.productDTO.pr_brand }}</div>
            </div>
            <div
              class="weui-cell"
              v-if="item.productDTO.pr_zxbzs"
              slot="pr_zxbzs"
            >
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.ad_qty || "最小包装数"
                }}</label>
              </div>
              <div class="weui-cell__bd">{{ item.productDTO.pr_zxbzs }}</div>
            </div>
            <div class="weui-cell" slot="ad_qty">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.ad_qty || "数量"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.ad_qty"
                  placeholder="请填写"
                />
              </div>
              <div class="weui-cell__ft">{{ item.productDTO.pr_unit }}</div>
            </div>
            <date-field
              slot="ad_delivery"
              :label="customLabel.ad_delivery || '需求日期'"
              v-model="item.ad_delivery"
            />
            <custom-field 
              :label="customLabel.ad_text1 || '自定义字段1'"
              v-model="item.ad_text1" :caller="caller" fieldName="ad_text1"
              slot="ad_text1" hidden="true"
            />
            <custom-field
              :label="customLabel.ad_text2 || '自定义字段2'"
              v-model="item.ad_text2" :caller="caller" fieldName="ad_text2"
              slot="ad_text2" hidden="true"
            />
            <custom-field 
              :label="customLabel.ad_text3 || '自定义字段3'"
              v-model="item.ad_text3" :caller="caller" fieldName="ad_text3"
              slot="ad_text3" hidden="true"
            />
            <custom-field 
              :label="customLabel.ad_text4 || '自定义字段4'"
              v-model="item.ad_text4" :caller="caller" fieldName="ad_text4"
              slot="ad_text4" hidden="true"
            />
            <custom-field 
              :label="customLabel.ad_text5 || '自定义字段5'"
              v-model="item.ad_text5" :caller="caller" fieldName="ad_text5"
              slot="ad_text5" hidden="true"
            />

            <a
              href="javascript:"
              v-if="xindex == form.items.length - 1"
              class="weui-cell weui-cell_link"
              @click="addItem"
            >
              <div class="weui-cell__bd">添加更多</div>
            </a>
          </custom-layout>
        </div>
      </div>

      <div class="weui-cells__group textarea-cell">
        <div class="weui-cells__title">备注</div>
        <div class="weui-cells">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="form.main.ap_remark"
                placeholder="请输入备注"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="weui-cells__group">
        <div class="weui-cells">
          <file-field v-model="form.main.ap_attach" />
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import ProductField from "@/components/field/ProductField.vue";
import DateField from "@/components/field/DateField.vue";
import FileField from "@/components/field/FileField.vue";
import process from "@/mixins/process.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  components: {
    CustomLayout,
    ProductField,
    DateField,
    FileField,
    CustomField
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/purchase/application",
      codeField: "ap_code",
      statusField: "ap_statuscode",
      caller: "Application",
      xtype: "purchase-application-formpanel",
      form: {
        main: {},
        items: [
          {
            ad_qty: 0,
            productDTO: {},
          },
        ],
      },
    };
  },
  methods: {
    /**
     * 选择明细产品
     */
    onSelectProduct(selection, item) {
      item.ad_prodid = selection.id;
      item.ad_prodcode = selection.pr_code;
      item.productDTO = Object.assign({}, selection);
    },
    /**
     * 保存
     */
    save() {
      var me = this,
        items = me.form.items,
        checked;
      var count = 0;
      items.forEach(function (item) {
        if (!item.ad_prodid) {
          me.$weui.topTips(`第${count + 1}行产品未选择`, 2000);
          return false;
        } else if (!item.ad_qty || item.ad_qty <= 0) {
          me.$weui.topTips(`第${count + 1}行数量未填写`, 2000);
          return false;
        } else {
          count++;
          item.ad_detno = count;
        }
      });
      checked = count == items.length;

      if (checked) {
        me.p_save();
      }
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({
        ad_qty: 0,
        productDTO: {},
      });
    },
  },
};
</script>